import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO, { SITE_URL } from './SEO';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import MobileApps from './MobileApps';
import CalculatorEnhanced from './CalculatorEnhanced';
import VideoTestimonials from './VideoTestimonials';
import PartnerLogos from './PartnerLogos';
import FAQ, { faqData } from './FAQ';
import Contact from './Contact';
import LiveDemoStrip from './LiveDemoStrip';
import Footer from './Footer';
import identity from '../data/siteIdentity.json';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location.state]);

  return (
    <>
      <SEO
        title="AI Receptionist & AI Automation Agency in Los Angeles | UBOTIKA"
        description="UBOTIKA is a Los Angeles AI automation agency: an AI receptionist that answers every call and books appointments 24/7, plus CRM automation and custom web apps."
        path="/"
        image={`${SITE_URL}/og/home.png`}
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            '@id': `${SITE_URL}/#organization`,
            name: identity.name,
            description: identity.description,
            url: SITE_URL,
            logo: `${SITE_URL}/ubotika-logo.png`,
            image: `${SITE_URL}/ubotika-logo.png`,
            telephone: identity.telephone,
            email: identity.email,
            address: {
              '@type': 'PostalAddress',
              addressLocality: identity.addressLocality,
              addressRegion: identity.addressRegion,
              addressCountry: identity.addressCountry,
            },
            areaServed: {
              '@type': 'City',
              name: 'Los Angeles',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: identity.telephone,
              contactType: 'customer service',
              availableLanguage: ['English'],
            },
            sameAs: identity.sameAs,
            knowsAbout: ['AI Agents', 'AI Phone Receptionists', 'CRM Automation', 'Workflow Automation', 'AI Call Handling'],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': `${SITE_URL}/#website`,
            name: 'UBOTIKA',
            url: SITE_URL,
            inLanguage: 'en-US',
            publisher: { '@id': `${SITE_URL}/#organization` },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          },
        ]}
      />
      <main id="main-content" className="studio-home">
        <Hero />
        <PartnerLogos />
        <Services />
        <About />
        <VideoTestimonials />
        <CalculatorEnhanced />
        <MobileApps />
        <FAQ />
        <LiveDemoStrip location="home-bottom" />
        <Contact />
        <Footer />
      </main>
    </>
  );
}

export default HomePage;
